import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/pro-solid-svg-icons";

import type { CardPillProps } from "./cardPill.types";

import s from "./cardPill.module.scss";

const CardPill = ({
  title,
  message,
  size = "sm",
  icon,
  iconProps,
  showActionButton = false,
  variant = "aqua",
  onAction
}: CardPillProps) => {
  const actionButton = showActionButton && size === "lg" && (
    <div className="card-action">
      <button
        aria-label="Botão de ação"
        className="card-action-button"
        type="button"
        onClick={onAction}
      >
        <FontAwesomeIcon data-testid="icon" icon={faChevronRight} />
      </button>
    </div>
  );

  return (
    <div
      className={`card-pill card-${variant} ${size} ${s.card_pill}`}
      data-card-lg={size === "lg"}
    >
      {icon && (
        <div className="card-icon">
          <FontAwesomeIcon data-testid="icon" icon={icon} {...iconProps} />
        </div>
      )}
      <div className="card-body">
        <span className="card-title">{title}</span>
        <span className="card-message">{message}</span>
      </div>
      {actionButton}
    </div>
  );
};

export default CardPill;
